module.exports = __webpack_public_path__ + "img/read.08de7685.svg";